import abort from '../../../javascripts/utils/abort';
import onLoad from '../../../javascripts/utils/onLoad';

onLoad<HTMLElement>('.quote-slider', ($quoteSlider) => {
  const $quotes = $quoteSlider.querySelector('.quote-slider__quotes') ?? abort();
  const $firstquote = $quotes.querySelector('.quote-slider__quote') ?? abort();
  const $leftButton = $quoteSlider.querySelector<HTMLButtonElement>('[data-quote-slider="left"]') ?? abort();
  const $rightButton = $quoteSlider.querySelector<HTMLButtonElement>('[data-quote-slider="right"]') ?? abort();

  const onScroll = () => {
    $leftButton.disabled = $quotes.scrollLeft <= $firstquote.clientWidth;
    $rightButton.disabled = $quotes.scrollLeft >= ($quotes.scrollWidth - $quotes.clientWidth - $firstquote.clientWidth);
  };

  $quotes.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  onScroll();

  $leftButton.addEventListener('click', (event) => {
    event.preventDefault();
    $quotes.scrollBy({ left: $quotes.clientWidth * -1 });
  });

  $rightButton.addEventListener('click', (event) => {
    event.preventDefault();
    $quotes.scrollBy({ left: $quotes.clientWidth });
  });
});
